module.exports = __webpack_public_path__ + "img/effect-3.78162fda.jpg";